import React from "react";
import { types } from "../enums/TypesEnum";
import { categories } from "../enums/CategoriesEnum";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";

const CosmeticFilters = ({
  pickedCategory,
  pickedType,
  setPickedCategory,
  setPickedType,
}: {
  pickedCategory: string | undefined;
  pickedType: string | undefined;
  setPickedCategory: Function;
  setPickedType: Function;
}) => {
  const clearFilters = () => {
    setPickedCategory(undefined);
    setPickedType(undefined);
  };

  return (
    <div className="category-container">
      {!pickedCategory &&
        categories.map((x) => (
          <div
            className="category"
            style={{
              borderBottom:
                pickedCategory === x.value ? "2px solid lightgray" : "none",
            }}
            key={x.value}
            onClick={() => setPickedCategory(x.value)}
          >
            {x.translations.find((x) => x.language === "pl")?.name}
          </div>
        ))}
      {pickedCategory && (
        <FontAwesomeIcon
          color="lightgrey"
          icon={faArrowLeft}
          style={{ height: "2.5em", marginRight: 10, cursor: "pointer" }}
          onClick={() => clearFilters()}
        />
      )}
      {types
        .find((x) => x.category === pickedCategory)
        ?.values.map((x) => (
          <div
            className="category"
            style={{
              borderBottom:
                pickedType === x.value ? "2px solid lightgray" : "none",
            }}
            key={x.value}
            onClick={() => setPickedType(x.value)}
          >
            {x.translations.find((x) => x.language === "pl")?.name}
          </div>
        ))}
    </div>
  );
};

export default CosmeticFilters;
